import "./App.css";
import Menu from "./Menu";
import Explore from "./components/Explore";
import Footer from "./Footer";
import { BrowserRouter as Router, Route, HashRouter } from "react-router-dom";
import Following from "./components/Following";
import Myitems from "./components/Myitems";
import Home from "./components/Home";
import Selector from "./components/Selector";
import Singleminter from "./components/Singleminter";
import Multiminter from "./components/Multiminter";
import Navigation from "./components/Navigation";
import Topnav from "./components/Topnav";
import { useEffect } from "react";
import SinglePost from "./components/SinglePost";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Tos from "./views/Tos";
import Community from "./views/Community";
import HowitWorks from "./views/HowitWorks";
import Singlenft from "./components/Singlenft";
import Moralis from "moralis";
import { useMoralis } from "react-moralis";
import Editprofile from "./components/Editprofile";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Category from "./components/Category";
import Web3 from "web3";

function App() {
  //const[loginState, setLoginState] = useState(false);
  const { isAuthenticated, user } = useMoralis();

  /*Start Moralis*/
  Moralis.start({
    serverUrl: "https://kquqmy2unesf.usemoralis.com:2053/server",
    appId: "lGFqxutUnQZXqqxy5N1optlMEzpT6RJW7BwbcMmw",
  });

  async function getNetwork() {
    const web3 = new Web3(window.ethereum);
    const net_id = await web3.eth.net.getId();
    if (net_id !== 56) {
      toast.warning("Connet to Binance Mainnet", { theme: "colored" });
    }
    /*Dectect Changes in Network*/
    const net_id_2 = await web3.eth.net.getId();
    window.ethereum.on("chainChanged", function (networkId) {
      console.log(networkId);
      if (networkId !== "0x38") {
        toast.warning("Connet to Binance Mainnet", { theme: "colored" });
      }

      //console.log('networkChanged',networkId);
    });
  }

  useEffect(() => {
    getNetwork();

    // window.addEventListener("contextmenu", (e) => e.preventDefault());
  }, []);

  return (
    <HashRouter>
      <div className="App">
        <ToastContainer />

        <Topnav></Topnav>

        <ToastContainer />
        <Route path="/" exact component={Home} />
        <Route path="/explore" component={Explore} />
        <Route path="/Following" component={Following} />
        <Route path="/myitems" component={Myitems} />
        <Route path="/selector" component={Selector} />
        <Route path="/singleminter" component={Singleminter} />
        <Route path="/multiminter" component={Multiminter} />
        <Route path="/author/:id" component={SinglePost}></Route>
        <Route path="/nftdetails/:id" component={Singlenft}></Route>
        <Route path="/category/:cat" component={Category}></Route>
        <Route path="/privacypolicy" component={PrivacyPolicy} />
        <Route path="/Tos" component={Tos} />
        <Route path="/community" component={Community} />
        <Route path="/howitworks" component={HowitWorks} />
        <Route path="/editprofile" component={Editprofile} />
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;
